// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IReturnMailDto } from './IReturnMailDto';
import {
    IReturnMailDtoFromJSON,
    IReturnMailDtoFromJSONTyped,
    IReturnMailDtoToJSON,
    IReturnMailDtoToJSONTyped,
} from './IReturnMailDto';
import type { IReturnedCheckDto } from './IReturnedCheckDto';
import {
    IReturnedCheckDtoFromJSON,
    IReturnedCheckDtoFromJSONTyped,
    IReturnedCheckDtoToJSON,
    IReturnedCheckDtoToJSONTyped,
} from './IReturnedCheckDto';

/**
 * 
 * @export
 * @interface IReturnedItemsDto
 */
export interface IReturnedItemsDto {
    /**
     * 
     * @type {Array<IReturnMailDto>}
     * @memberof IReturnedItemsDto
     */
    returned_mails?: Array<IReturnMailDto>;
    /**
     * 
     * @type {Array<IReturnedCheckDto>}
     * @memberof IReturnedItemsDto
     */
    returned_checks?: Array<IReturnedCheckDto>;
}

/**
 * Check if a given object implements the IReturnedItemsDto interface.
 */
export function instanceOfIReturnedItemsDto(value: object): value is IReturnedItemsDto {
    return true;
}

export function IReturnedItemsDtoFromJSON(json: any): IReturnedItemsDto {
    return IReturnedItemsDtoFromJSONTyped(json, false);
}

export function IReturnedItemsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReturnedItemsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'returned_mails': json['returned_mails'] == null ? undefined : ((json['returned_mails'] as Array<any>).map(IReturnMailDtoFromJSON)),
        'returned_checks': json['returned_checks'] == null ? undefined : ((json['returned_checks'] as Array<any>).map(IReturnedCheckDtoFromJSON)),
    };
}

export function IReturnedItemsDtoToJSON(json: any): IReturnedItemsDto {
    return IReturnedItemsDtoToJSONTyped(json, false);
}

export function IReturnedItemsDtoToJSONTyped(value?: IReturnedItemsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'returned_mails': value['returned_mails'] == null ? undefined : ((value['returned_mails'] as Array<any>).map(IReturnMailDtoToJSON)),
        'returned_checks': value['returned_checks'] == null ? undefined : ((value['returned_checks'] as Array<any>).map(IReturnedCheckDtoToJSON)),
    };
}

